import React from 'react';
import './App.css';
import Artistes from './components/ArtistesDecors/ArtistesDecors' ;
import ArtistesDyn    from './components/Artistes/ArtistesDyn/ArtistesDyn' ;

import NavIdentification from './components/NavIdentification/NavIdentification' ;
import Home              from './components/Pages/Home/Home' ;
import Galerie           from './components/Pages/Galerie/Galerie' ;
import Footer            from './components/Pages/Footer/Footer' ;
import NavBar            from './components/NavBar/NavBar' ;
import Agenda            from './components/Pages/Agenda/Agenda' ;
import PagesExos         from './components/Pages/PageExos/PagesExos' ;
import ExosFunction      from './components/Pages/PageExos/ExosFunction' ;
import GalerieVirtuelle  from './components/Pages/GalerieVirtuelle/GalerieVirtuelle' ;
import NousRejoindre     from './components/Pages/NousRejoindre/NousRejoindre' ;
import Videos            from './components/Pages/Videos/Videos' ;
import PageNotFound      from './components/Pages/PageNotFound/PageNotFound' ;

import Cgv               from './components/Pages/CGV/CGV' ;
import Partenaires       from './components/Pages/Partenaires/Partenaires' ;
import NavResponsiv      from './components/Pages/NavResponsiv/NavResponsiv' ;
import Cookies           from './components/Pages/Cookies/Cookies' ;
import CookieConsent     from "react-cookie-consent" ;


import ScrollToTop       from './components/ScrollToTop/ScrollToTop' ;

import {useTranslation } from 'react-i18next'

import { BrowserRouter, Route, Switch,  Link} from 'react-router-dom';

function App() {

     useTranslation()
    
  return (
    <BrowserRouter>
    <ScrollToTop />
      <NavIdentification />
     
      <NavBar/>   
      
        <Switch>

          <Route path="/" exact                 component={Home}/>
          <Route path="/index.html"              component={Home}/>
          <Route path="/galerie"                  component={Galerie}/>
          <Route path="/agenda"                   component={Agenda}/>
          <Route path="/GalerieVirtuelle"         component={GalerieVirtuelle}/>
          <Route path="/NousRejoindre"            component={NousRejoindre}/>
          <Route path="/Exos"                     component={PagesExos}/>
          <Route path="/ExosFunction"             component={ExosFunction}/>
          <Route path="/Videos"                   component={Videos}/>
          <Route path="/Cgv"                      component={Cgv}/>
          <Route path="/Cookies"                 component={Cookies}/>
          <Route path="/Partenaires"              component={Partenaires}/>
          
          <Route path="/artistes" exact                component={Artistes}/>
          <Route path="/artistes/:NameURL"             component={ArtistesDyn}/>
          

          <Route                                component={PageNotFound}/>

        </Switch>
       
      <Footer/>
      <NavResponsiv />
      <div className="d-none d-sm-block">
      <CookieConsent
        location="bottom"
        buttonText="Accepter"
        containerClasses="col-lg-12 text-center"
        buttonStyle={{ color: "#4e503b",background: "white", fontSize: "13px" }}
        cookieName="ArtAndGalleries"
        style={{ background: "#8d010e" }}
        // onAccept={() => {setValue(true)}}
        hideOnAccept={true}
        expires={150}
      >
        En poursuivant votre visite, vous acceptez l'utilisation de cookies.<p className="font-italic text-info"><Link to="/Cookies">pour en savoir plus</Link></p> 
        </CookieConsent>
      </div>
      
    </BrowserRouter>
  );
}

export default App;
